module.exports = __webpack_public_path__ + "media/packs/images/state/small/exchange-8d315e30f0f49dcbd1a758847212e7b7.svg";